module.exports = __webpack_public_path__ + "static/media/token-preview-banana.da6a8e81.png";